import React from "react";
import { HiArrowLeft } from "react-icons/hi";
const BackBtn = ({ onBack }) => {
  return (
    <div className="absolute left-5 top-5 sm:top-10 sm:left-16">
      <div className="flex items-center">
        <div
          className="cursor-pointer bg-primary w-8 h-8 3xl:w-11 3xl:h-11 border border-customBlack hover:border-customBlack hover:bg-secondary flex justify-center items-center text-customBlack rounded-full group transition-all duration-300 ease-in-out"
          onClick={onBack}
        >
          <HiArrowLeft className="text-xl 3xl:text-2xl group-hover:text-primary transition-colors duration-300 ease-in-out" />
        </div>
        <div className="text-secondary ml-2">Back</div>
      </div>
    </div>
  );
};
export default BackBtn;
